'use strict';

/**
 * Short “how to use this screen” copy for the lesson shell Clue panel (first hint),
 * keyed by guided lesson `activityType`. Not shown in the main activity card.
 */

function norm(t) {
  if (t == null) return '';
  return String(t)
    .trim()
    .toLowerCase()
    .replace(/-/g, '_')
    .replace(/\s+/g, '_');
}

/** @returns {{ text: string, audioText: string } | null} */
export function getShellMechanicHint(activityType) {
  const t = norm(activityType);
  const map = {
    exploration_card:
      'Tap Next card for each tour stop. At the end, tap Finish tour.',
    exploration_cards:
      'Tap Next card for each tour stop. At the end, tap Finish tour.',
    match: 'Tap a clue first, then tap the option that matches.',
    drag_drop: 'Tap a clue first, then tap the option that matches.',
    multiple_choice: 'Tap an answer to choose it.',
    quiz: 'Tap an answer to choose it.',
    sequence:
      'Tap steps to build your order in the numbered slots, then tap Check. On wider layouts you may also see arrow buttons to reorder rows.',
    sequencing:
      'Tap steps to build your order in the numbered slots, then tap Check. On wider layouts you may also see arrow buttons to reorder rows.',
    pattern: 'Tap a choice to answer, then tap Check if the activity asks you to.',
    canvas: 'Tap a piece in the tray to select it, then tap the zone where it belongs. Tap Check when all pieces are placed.',
    canvas_manipulative: 'Tap a piece in the tray to select it, then tap the zone where it belongs. Tap Check when all pieces are placed.',
    tap_on_image: 'Tap the spots the activity marks on the picture.',
    hotspots: 'Tap the spots the activity marks on the picture.',
    simulation: 'Use Previous and Next (or the + and − buttons) to move through the scene. Tap Check answer when it matches the goal.',
    simulation_scrub:
      'Use Previous and Next (or the + and − buttons) to move through the scene. Tap Check answer when it matches the goal.',
    gear: 'Tap a gear size or control the activity shows. Tap Check when you are ready.',
    gear_ratio: 'Tap a gear size or control the activity shows. Tap Check when you are ready.',
    circuit: 'Tap the gold dots to connect parts, or tap the choices the activity gives you. Tap Check when the lamp can glow.',
    circuit_builder:
      'Tap two gold terminals on the diagram to draw wires. Tap Check when you think the LED can glow — coaching and the lit LED show after Check.',
    gear_direction: 'Tap the gears that match the spin rule, then Check below. The train spins after Check.',
    gear_speed:
      'Tap a gear or number, then Check below. On fastest/slowest steps the train spins after Check; turn-count steps keep the train moving for reference.',
    circuit_path:
      'Tap each gap to cycle wire pieces until the path looks right, then tap Check below — the bulb glows after Check.',
    switch_logic:
      'Tap switches ON or OFF. On AND puzzles the output lights only after Check below; OR previews live. Tap Check when the pattern matches.',
    system_flow: 'Tap the side arrows to move each part earlier or later in the chain, then tap Run when the order matches.',
    variable_simulation: 'Tap + and − or the slider to change the value. Read the captions, then tap Check when you reach the goal.',
    evidence_detective: 'Tap clue cards to reveal them, pick your best answer, then tap Submit.',
  };
  const text = map[t];
  if (!text) return null;
  return { text, audioText: text };
}
